module.exports = __webpack_public_path__ + "img/Nick_Tyson.928e1176.jpeg";